module.exports = __webpack_public_path__ + "img/intelligent01.58732691.png";